<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='18'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <div style="width:100%;height:30px;padding-top: 5px;">
            <el-button type="primary" size="mini" round plain @click="Createtask()">添加订单</el-button>
            <el-button type="primary" size="mini" round plain @click="Uploadorder()" icon="el-icon-upload2">订单EXCEl上传</el-button>
            <el-select style="margin-left: 5px;" v-model="userIdList" size="mini" placeholder="请选择业务员" multiple clearable>
              <el-option
                v-for="item in optionsUserList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button type="primary" size="mini" @click="BatchUser">确定分配订单</el-button>
            <div style="float: right;">
              <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="dialogVisible = true"></i>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <el-row>
              <!-- <el-col :span="4">
                <el-select v-model="listQuery.user_id" placeholder="请选择业务员" clearable @change="searchUser" size="small">
                  <el-option
                    v-for="item in optionsUserList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col> -->
              <el-col :span="4">
                <el-select v-model="listQuery.is_complete" clearable placeholder="是否完成" size="small" @change="searchUser">
                  <el-option label="否" value="1"></el-option>
                  <el-option label="是" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-input size="small" v-model="listQuery.search" clearable placeholder="请输入物料编码或物料描述" style="width: 300px;" class="filter-item">
                  <el-button slot="append" @click="searchUser">搜索</el-button>
                </el-input>
              </el-col>
            </el-row>
            <el-row style="position: static;margin-top: 8px;">
              <el-col :span="24" class="task">
                <el-table ref="singleTable" :data="list" border v-loading="qyloading" style="width: 100%">
                  <el-table-column align="center" prop="addtime" label="日期" sortable width="100"></el-table-column>
                  <el-table-column align="center" label="工厂名称（编码）" width="150">
                    <template slot-scope="{row}">
                      <span>{{ row.factory_name + '（' + row.factory_code + '）' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="purchase_order_num" label="采购订单号" width="110"></el-table-column>
                  <el-table-column align="center" prop="material_code" label="物料编码" width="105"></el-table-column>
                  <el-table-column align="center" prop="material_des" label="物料描述" width="110"></el-table-column>
                  <el-table-column align="center" prop="number" label="数量" width="50"></el-table-column>
                  <el-table-column align="center" prop="units" label="单位" width="50"></el-table-column>
                  <el-table-column align="center" prop="tax_price" label="单价" width="70"></el-table-column>
                  <el-table-column align="center" prop="total_price" label="总价"></el-table-column>
                  <el-table-column align="center" prop="tracking_num" label="申购人" width="110"></el-table-column>
                  <el-table-column label="是否完成" align="center" width="120">
                    <template slot-scope="{row}">
                      <el-switch
                        v-model="row.is_complete"
                        active-value="2"
                        active-text="是"
                        active-color="#13ce66"
                        inactive-text="否"
                        inactive-value="1"
                        inactive-color="#ff4949"
                        @change="changeIscomplete(row, 'is_complete')"
                      >
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="订单分配" width="150">
                    <template slot-scope="{row}">
                      <el-select v-model="row.user_id" placeholder="请选择" multiple clearable @change="changUser(row)">
                        <el-option
                          v-for="item in optionsUserList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column type="selection" width="50"></el-table-column>
                  <!-- <el-table-column align="center" prop="id" label="序号"></el-table-column> -->
                  <el-table-column align="center" prop="order_num" label="序号" width="50"></el-table-column>
                  <el-table-column align="center" prop="delivery_location" label="收货库存地点" width="105"></el-table-column>
                  <el-table-column label="操作" align="center"  fixed="right" width="90">
                    <template slot-scope="scopes">
                      <el-button size="mini" type="text" @click="handleEdit(scopes.$index, scopes.row)">编辑</el-button>
                      <el-popover
                        :ref="`popover-${scopes.$index}`"
                        placement="top"
                        width="160"
                        trigger="click"
                        style="margin-left: 10px;"
                      >
                        <p>确定删除该订单吗？</p>
                        <div style="text-align: right; margin: 0;">
                          <el-button size="mini" type="text" @click="scopes._self.$refs[`popover-${scopes.$index}`].doClose()">取消</el-button>
                          <el-button type="primary" size="mini" @click="handleDelete(scopes.row,scopes.$index,scopes)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="text">删除</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getBusinessOrdersList" :pageSizes="[5, 10, 15, 20, 25]"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
    <el-dialog title="订单编辑" :visible.sync="dialogFormVisible" width="70%" :close-on-click-modal="false">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <div v-loading="qyloading">
          <div class="ant-card">
            <div class="ant-card-head">
              <div class="ant-card-head-wrapper">
                <div class="ant-card-head-title">订单详情</div>
              </div>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="采购订单号" prop="purchase_order_num" label-width="140px">
                  <el-input v-model="formData.purchase_order_num" placeholder="请输入采购订单号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="工厂名称" prop="factory_name" label-width="140px">
                  <el-input v-model="formData.factory_name" placeholder="请输入工厂名称"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="收货库存地点" prop="delivery_location" label-width="140px">
                  <el-input v-model="formData.delivery_location" placeholder="请输入收货库存地点"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="采购订单创建日期" label-width="140px">
                  <el-date-picker
                    v-model="formData.addtime"
                    type="date"
                    placeholder="请选择采购订单创建日期"
                    :clearable="false"
                    style="width:100%"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="ant-card">
            <div class="ant-card-head">
              <div class="ant-card-head-wrapper">
                <div class="ant-card-head-title">商品信息</div>
                <div class="ant-card-head-button">
                  <el-button v-if="formData.filename" slot="trigger" type="primary" icon="el-icon-download" style="margin:0px 6px 6px 20px;float:left;" @click="DownQuotation(formData.filename)">订单EXCEl下载</el-button>
                  <el-popover v-model="visible" placement="top" width="200px" style="margin:0px 6px 6px 20px;float:left;">
                    <p>确定清空吗？</p>
                    <div style="text-align: right; margin: 0;">
                      <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                      <el-button type="primary" size="mini" @click="ClearGoodsMessage">确定</el-button>
                    </div>
                    <el-button slot="reference" icon="el-icon-delete">清空表单</el-button>
                  </el-popover>
                  <div class="filter-container">
                    <el-input v-model="SearchData" placeholder="请输入序号" style="width: 200px;padding-bottom:4px" class="filter-item" />
                    <el-button class="filter-item" type="primary" icon="el-icon-search" @click="goNum">搜索</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="(item,index) in goodsMessage" :key="index" class="ant-card-bottom">
              <el-form :ref="'item'+index" :model="item" :rules="rules" style="padding-bottom: 0;">
                <el-row :class="'goNum_'+item.order_num">
                  <el-col :span="1">
                    <el-form-item label="序号" prop="order_num">
                      <div style="width: 30px;height: 30px;font-size: 15px;">{{ item.order_num }}</div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" style="margin-left: 5px;">
                    <el-form-item label="物料编码" prop="material_code">
                      <el-autocomplete
                        v-model="item.material_code"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入物料编码"
                        :title="item.material_code"
                        clearable
                        style="width:100%"
                        @select="handleSelect($event, index)"
                      ></el-autocomplete>
                      <el-link v-if="goodsMessage.length > 1" type="primary" @click="delMsg(index)">删除</el-link>&nbsp;
                      <el-link type="primary" @click="addMsg">添加</el-link>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" style="margin-left: 5px;">
                    <el-form-item label="物料描述" prop="material_des">
                      <el-input v-model="item.material_des" placeholder="请输入物料描述" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" style="margin-left: 5px;">
                    <el-form-item label="数量" prop="number">
                      <el-input v-model="item.number" placeholder="请输入数量" min="1" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" style="margin-left: 5px;">
                    <el-form-item label="单位" prop="units">
                      <el-input v-model="item.units" placeholder="单位" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" style="margin-left: 5px;">
                    <el-form-item label="单价" prop="tax_price">
                      <el-input v-model="item.tax_price" placeholder="单价" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3" style="margin-left: 5px;">
                    <el-form-item label="需求跟踪号">
                      <el-input v-model="item.tracking_num" placeholder="需求跟踪号" clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveBusinessOrders()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="订单EXCEl上传" :visible.sync="dialogOrderVisible" width="20%">
      <el-form :model="formOrderData" :rules="ruless" ref="FormOrder" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col>
            <el-form-item label="模板类型" prop="templateType">
              <el-select v-model="formOrderData.templateType" clearable placeholder="请选择模板类型" size="small">
                <el-option label="蒙牛" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="上传文件" prop="filename">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="upload_url"
                :on-success="handlesuccess"
                :before-upload="beforeAvatarUpload"
                accept=".xls,.xlsx"
                :file-list="fileList"
                :headers="requestHeaders"
                :auto-upload="true"
                :multiple="false"
                :limit="1">
                <el-button slot="trigger" size="small" type="primary">上传模板文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogOrderVisible = false">取 消</el-button>
        <el-button type="primary" @click="importBusOrder()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="订单管理说明" :visible.sync="dialogVisible" width="50%">
      <el-carousel :autoplay="false" arrow="always" indicator-position="none" height="700px">
        <el-carousel-item v-for="(item,index) in srcList" :key="index">
          <el-image
            style="width: 100%;"
            :src="item"
            :preview-src-list="srcList">
          </el-image>
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/businessOrders'
import { getToken } from '@/utils/auth'
import apiConfig from '../../../config/api.config.js'
import CountTo from 'vue-count-to'

export default {
  name: 'BusinessOrders',
  components: { Top, LeftNav, Bottom, Pagination, CountTo },
  data () {
    return {
      api,
      list: [],
      total: 0,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_business_orders',
      requestHeaders: {
        'X-Token': getToken()
      },
      qyloading: false,
      fileList: [],
      listQuery: {
        limit: 5,
        order: 'order_num',
        page: 1,
        sort: 'ASC'
      },
      dialogFormVisible: false,
      dialogOrderVisible: false,
      locktype: false,
      formData: {
        id: null,
        purchase_order_num: '',
        factory_name: '',
        delivery_location: '',
        addtime: new Date(),
        filename: '',
        goodsMessage: []
      },
      formOrderData: {
        templateType: '',
        filename: ''
      },
      goodsMessage: [
        {
          order_num: 1,
          material_code: '',
          material_des: '',
          number: 1,
          units: '',
          tax_price: '',
          tracking_num: '',
          is_delete: 1
        }
      ], // 货品信息
      rules: {
        purchase_order_num: [{ required: true, message: '请输入采购订单号', trigger: 'blur' }],
        factory_name: [{ required: true, message: '请输入工厂名称', trigger: 'blur' }],
        delivery_location: [{ required: true, message: '请输入收货库存地点', trigger: 'blur' }],
        material_code: [{ required: true, message: '请输入物料编码', trigger: 'blur' }],
        material_des: [{ required: true, message: '请输入物料描述', trigger: 'blur' }],
        number: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        units: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        tax_price: [{ required: true, message: '请输入单价', trigger: 'blur' }]
      }, // 上传订单
      ruless: {
        templateType: [{ required: true, message: '请选择模板类型', trigger: 'blur' }],
        filename: [{ required: true, message: '请上传模板文件', trigger: 'change' }]
      },
      visible: false,
      SearchData: '',
      dialogVisible: false,
      srcList: [
        'https://serv.nmzp.com/uploads/1/image/20240422/6687fd0195ca2376df44e5d3201a79b3.png',
        'https://serv.nmzp.com/uploads/1/image/20240422/edd1ff9871497b4d7cf9514d4211d323.png'
      ],
      optionsUserList: [],
      userIdList: [],
      primary_key: 'business_orders_goods_id'
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.getUserList()
    this.getBusinessOrdersList()
  },
  methods: {
    getUserList () {
      api.getUserList({MAccountRole: '1, 5'}).then(response => {
        this.optionsUserList = response.data
      })
    },
    getBusinessOrdersList () {
      this.qyloading = true
      this.listQuery.user_id = this.current_user.id
      // if (this.current_user.id === 70) {
      //   this.$delete(this.listQuery, 'user_id')
      // }
      api.getBusinessOrdersList(this.listQuery).then(response => {
        this.list = response.data.items
        this.total = response.data.total
        this.isLoading = false
        this.qyloading = false
      })
    },
    importBusOrder () {
      this.$refs['FormOrder'].validate((valid) => {
        if (valid) {
          api.importBusOrder(this.formOrderData).then((response) => {
            if (response.code === 20000) {
              this.$notify({
                title: '成功',
                message: response.message,
                type: 'success'
              })
              this.dialogOrderVisible = false
              this.getBusinessOrdersList()
            }
          })
        }
      })
    },
    changeIscomplete (row, fieldName) {
      const params = { id: row.business_orders_goods_id }
      params[fieldName] = row[fieldName]
      api.changeIscomplete(params).then(res => {
        if (res.code === 20000) {
          this.$message({ message: '操作成功', type: 'success' })
        } else {
          this.$message({ message: '操作失败', type: 'error' })
        }
      })
    },
    DownQuotation (e) {
      window.open(e)
    },
    addMsg (index) {
      // if (this.goodsMessage.length + 1 > 10) {
      //   return
      // }
      var num = this.goodsMessage.length - 1
      this.goodsMessage.push({
        order_num: this.goodsMessage[num].order_num + 1,
        material_code: '',
        material_des: '',
        number: 1,
        units: '',
        tax_price: '',
        tracking_num: '',
        is_delete: 1
      })
    },
    delMsg (index) {
      var numold = this.goodsMessage[0].order_num
      this.goodsMessage.splice(index, 1)
      var numnew = this.goodsMessage[0].order_num
      // 重新排序
      for (var i = index; i < this.goodsMessage.length; i++) {
        if (index === 0) {
          this.goodsMessage[i].order_num = i + numold
        } else {
          this.goodsMessage[i].order_num = i + numnew
        }
      }
    },
    Createtask () {
      this.dialogFormVisible = true
      this.formData = {
        id: null,
        purchase_order_num: '',
        factory_name: '',
        delivery_location: '',
        addtime: new Date(),
        filename: '',
        goodsMessage: []
      }
      this.goodsMessage = [
        {
          order_num: 1,
          material_code: '',
          material_des: '',
          number: 1,
          units: '',
          tax_price: '',
          tracking_num: '',
          is_delete: 1
        }
      ]
    },
    Uploadorder () {
      this.dialogOrderVisible = true
    },
    handleEdit (index, row) {
      this.dialogFormVisible = true
      // this.formData = Object.assign({}, row)
      // this.goodsMessage = row.goodsMessage
      api.getDetail({ id: row.id }).then(response => {
        if (response.code === 20000) {
          this.formData = response.items
          this.goodsMessage = response.items.goodsMessage
        } else {
          this.$message.error(response.message)
        }
      })
    },
    handlesuccess (response, file) {
      this.subloading = false
      if (response.code === 20000) {
        // this.formData.filename = response.message
        this.formOrderData.filename = response.savename
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      this.subloading = true
      return (extension || extension2) && isLt2M
    },
    handleDelete (row, index, scopes) {
      api.handleDelete({ id: row.business_orders_goods_id }).then(response => {
        this.getBusinessOrdersList()
        scopes._self.$refs[`popover-${scopes.$index}`].doClose()
      })
    },
    querySearchAsync (queryString, cb) {
      let results = []
      if (queryString === '') {
        this.restaurants = [{ value: '暂无匹配信息' }]
        cb(this.restaurants)
      } else {
        if (queryString) {
          api.searchGoods({ 'search': queryString }).then(response => {
            this.restaurants = response.items
            // const findout = this.restaurants.filter((x) => this.nameFilter(x, queryString))
            results = this.restaurants.map(x => ({ ...x, value: x.title }))
            if (results.length > 0) {
              clearTimeout(this.timeout)
              this.timeout = setTimeout(() => {
                cb(results)
              }, 1000 * Math.random())
            } else {
              const nodata = [{ value: '暂无匹配信息' }]
              cb(nodata)
            }
          })
        }
      }
    },
    handleSelect (item, index) {
      this.goodsMessage[index].material_code = item.mengniu_code
      this.goodsMessage[index].material_des = item.title
      this.goodsMessage[index].units = item.units
      this.goodsMessage[index].tax_price = item.tax_price
    },
    ClearGoodsMessage () {
      this.goodsMessage = [
        {
          order_num: 1,
          material_code: '',
          material_des: '',
          number: 1,
          units: '',
          tax_price: '',
          tracking_num: '',
          is_delete: 1
        }
      ]
      this.visible = false
    },
    goNum () {
      this.$el.querySelector('.goNum_' + this.SearchData).scrollIntoView({ block: 'start', behavior: 'smooth' })
      document.getElementsByClassName('goNum_' + this.SearchData)[0].classList.add('highlight')
      setTimeout(() => {
        document.getElementsByClassName('goNum_' + this.SearchData)[0].classList.remove('highlight')
      }, 5000)
    },
    saveBusinessOrders () {
      const This = this
      this.goodsMessage.forEach((item, index) => {
        // 有多个输入框需校验，待都校验成功后再进行别的操作，所以需要使用Promise
        // 划重点：This.$refs['item'+index][0]
        This.$refs['item' + index][0].validate((valid) => {
          if (valid) {
          }
        })
      })
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.locktype) {
            // return false
          }
          this.locktype = true
          this.formData.goodsMessage = this.goodsMessage
          // this.formData.user_id = this.current_user.id
          api.saveBusinessOrders(this.formData).then(response => {
            this.dialogFormVisible = false
            this.locktype = false
            this.getBusinessOrdersList()
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
          })
        }
      })
    },
    changUser (row) {
      const params = { id: row.business_orders_goods_id }
      params['user_id'] = row.user_id
      api.changUser(params).then(res => {
        if (res.code === 20000) {
          this.$message({ message: '分配成功', type: 'success' })
        } else {
          this.$message({ message: '分配失败', type: 'error' })
        }
      })
    },
    searchUser () {
      this.listQuery.page = 1
      this.getBusinessOrdersList()
    },
    // 批量修改分配
    BatchUser () {
      if (this.$refs.singleTable.selection.length > 0) {
        if (this.userIdList.length === 0) {
          this.$message({ message: '请选择业务员', type: 'error' })
          return
        }
        var ids = this.$refs.singleTable.selection.map(a => a[this.primary_key])
        api.changUser({id: ids, user_id: this.userIdList}).then(response => {
          if (response.code === 20000) {
            this.$message({ message: '操作成功', type: 'success' })
            this.getBusinessOrdersList() // 重新加载数据
          } else {
            this.$message({ message: '操作失败', type: 'error' })
          }
        })
      } else {
        this.$message({ message: '请选择分配的数据', type: 'error' })
      }
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 25px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 86%;
}
.ant-card-head {
  min-height: 48px;
  margin-bottom: 40px;
  padding: 0 24px;
  color: rgba(0, 0, 0, .85);
  font-weight: 500;
  font-size: 16px;
  background: 0 0;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
  background: #f8faff;
}
.ant-card-head-title {
  color: #1890ff;
  padding-top: 10px;
  float: left;
}
.ant-card-head-button {
  width: 90%;
  padding-top: 5px;
  float: left;
}
.filter-container {
  text-align: right;
  display: inline-block;
  float: right;
}
.highlight{
  background-color: #f0f0f0;
}
.el-popper{
  width:600px !important;
}
.ant-card-bottom{
  border-bottom: 2px solid #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/view/member/business_orders.vue